import { IActionFieldInfo, IAuditOnsiteFieldInfo } from "../../../../interfaces";

export const getSingleLabelArrayHandler = (fields: IAuditOnsiteFieldInfo[], labelName:string) =>
  fields.filter(el => el.label === labelName);

export const getSingleActionLabelArrayHandler = (fields: IActionFieldInfo[], labelName:string) =>
  fields.filter(el => el.label === labelName);